<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </section>
</template>

<script>
import lang from '@/options/lang'
export default {
  name: 'AppMain',
  computed: {

  }
}
</script>

<style>
.app-main {
  min-height: calc(100vh);
  position: relative;
  overflow: hidden;
  border-left:1px solid #e6e6e6;
}
.padding-container {
  padding:20px;
}
</style>



// WEBPACK FOOTER //
// src/views/controlCenter/layout/components/AppMain.vue